// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/form/v1/form.proto" (package "c1.api.form.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Int64Rules } from "../../../../validate/validate";
import { RepeatedRules } from "../../../../validate/validate";
import { BoolRules } from "../../../../validate/validate";
import { StringRules } from "../../../../validate/validate";
/**
 * A form is a collection of fields to be filled out by a user
 *
 * @generated from protobuf message c1.api.form.v1.Form
 */
export interface Form {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 3;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 4;
     */
    description: string;
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.Field fields = 5;
     */
    fields: Field[];
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.FieldRelationship field_relationships = 6;
     */
    fieldRelationships: FieldRelationship[];
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.FieldGroup field_groups = 7;
     */
    fieldGroups: FieldGroup[];
}
/**
 * A field is a single input meant to collect a piece of data from a user
 *
 * @generated from protobuf message c1.api.form.v1.Field
 */
export interface Field {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string; // Must be unique across all Fields in a Form, probably auto-generated in UI
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string; // AKA "label"
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string; // AKA "helper_text"
    /**
     * @generated from protobuf field: bool required = 4;
     */
    required: boolean;
    /**
     * @generated from protobuf oneof: type
     */
    type: {
        oneofKind: "stringField";
        /**
         * @generated from protobuf field: c1.api.form.v1.StringField string_field = 100;
         */
        stringField: StringField;
    } | {
        oneofKind: "boolField";
        /**
         * @generated from protobuf field: c1.api.form.v1.BoolField bool_field = 101;
         */
        boolField: BoolField;
    } | {
        oneofKind: "stringSliceField";
        /**
         * @generated from protobuf field: c1.api.form.v1.StringSliceField string_slice_field = 102;
         */
        stringSliceField: StringSliceField;
    } | {
        oneofKind: "int64Field";
        /**
         * @generated from protobuf field: c1.api.form.v1.Int64Field int64_field = 103;
         */
        int64Field: Int64Field;
    } | {
        oneofKind: "fileField";
        /**
         * @generated from protobuf field: c1.api.form.v1.FileField file_field = 104;
         */
        fileField: FileField;
    } | {
        oneofKind: "oauth2Field";
        /**
         * @generated from protobuf field: c1.api.form.v1.Oauth2Field oauth2_field = 105;
         */
        oauth2Field: Oauth2Field;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: provider_config
     */
    providerConfig: {
        oneofKind: "userConfig";
        /**
         * @generated from protobuf field: c1.api.form.v1.UserProviderConfig user_config = 200;
         */
        userConfig: UserProviderConfig;
    } | {
        oneofKind: "adminConfig";
        /**
         * @generated from protobuf field: c1.api.form.v1.AdminProviderConfig admin_config = 201;
         */
        adminConfig: AdminProviderConfig;
    } | {
        oneofKind: "sharedConfig";
        /**
         * @generated from protobuf field: c1.api.form.v1.SharedProviderConfig shared_config = 202;
         */
        sharedConfig: SharedProviderConfig;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.UserProviderConfig
 */
export interface UserProviderConfig {
    /**
     * @generated from protobuf field: string input_transformation_cel = 1;
     */
    inputTransformationCel: string;
}
/**
 * @generated from protobuf message c1.api.form.v1.AdminProviderConfig
 */
export interface AdminProviderConfig {
    /**
     * @generated from protobuf field: string default_value_cel = 1;
     */
    defaultValueCel: string;
    /**
     * @generated from protobuf field: bool show_to_user = 2;
     */
    showToUser: boolean;
}
/**
 * @generated from protobuf message c1.api.form.v1.SharedProviderConfig
 */
export interface SharedProviderConfig {
    /**
     * @generated from protobuf field: string default_value_cel = 1;
     */
    defaultValueCel: string;
    /**
     * @generated from protobuf field: bool lock_default_values = 2;
     */
    lockDefaultValues: boolean;
    /**
     * @generated from protobuf field: string input_transformation_cel = 3;
     */
    inputTransformationCel: string;
}
/**
 * @generated from protobuf message c1.api.form.v1.StringField
 */
export interface StringField {
    /**
     * @generated from protobuf field: string default_value = 1;
     */
    defaultValue: string;
    /**
     * @generated from protobuf field: optional validate.StringRules rules = 2;
     */
    rules?: StringRules;
    /**
     * @generated from protobuf field: string placeholder = 3;
     */
    placeholder: string;
    /**
     * @generated from protobuf oneof: view
     */
    view: {
        oneofKind: "textField";
        /**
         * @generated from protobuf field: c1.api.form.v1.TextField text_field = 100;
         */
        textField: TextField;
    } | {
        oneofKind: "passwordField";
        /**
         * @generated from protobuf field: c1.api.form.v1.PasswordField password_field = 101;
         */
        passwordField: PasswordField;
    } | {
        oneofKind: "selectField";
        /**
         * @generated from protobuf field: c1.api.form.v1.SelectField select_field = 104;
         */
        selectField: SelectField;
    } | {
        oneofKind: "pickerField";
        /**
         * @generated from protobuf field: c1.api.form.v1.PickerField picker_field = 103;
         */
        pickerField: PickerField;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.TextField
 */
export interface TextField {
    /**
     * @generated from protobuf field: bool multiline = 1;
     */
    multiline: boolean;
}
/**
 * @generated from protobuf message c1.api.form.v1.PasswordField
 */
export interface PasswordField {
}
/**
 * @generated from protobuf message c1.api.form.v1.Oauth2Field
 */
export interface Oauth2Field {
    /**
     * @generated from protobuf oneof: view
     */
    view: {
        oneofKind: "oauth2FieldView";
        /**
         * @generated from protobuf field: c1.api.form.v1.Oauth2FieldView oauth2_field_view = 100;
         */
        oauth2FieldView: Oauth2FieldView;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.Oauth2FieldView
 */
export interface Oauth2FieldView {
}
/**
 * @generated from protobuf message c1.api.form.v1.BoolField
 */
export interface BoolField {
    /**
     * @generated from protobuf field: bool default_value = 1;
     */
    defaultValue: boolean;
    /**
     * @generated from protobuf field: optional validate.BoolRules rules = 2;
     */
    rules?: BoolRules;
    /**
     * @generated from protobuf oneof: view
     */
    view: {
        oneofKind: "checkboxField";
        /**
         * @generated from protobuf field: c1.api.form.v1.CheckboxField checkbox_field = 100;
         */
        checkboxField: CheckboxField;
    } | {
        oneofKind: "toggleField";
        /**
         * @generated from protobuf field: c1.api.form.v1.ToggleField toggle_field = 101;
         */
        toggleField: ToggleField;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.CheckboxField
 */
export interface CheckboxField {
}
/**
 * @generated from protobuf message c1.api.form.v1.ToggleField
 */
export interface ToggleField {
}
/**
 * @generated from protobuf message c1.api.form.v1.StringSliceField
 */
export interface StringSliceField {
    /**
     * @generated from protobuf field: repeated string default_values = 1;
     */
    defaultValues: string[];
    /**
     * @generated from protobuf field: string placeholder = 3;
     */
    placeholder: string;
    /**
     * @generated from protobuf field: optional validate.RepeatedRules rules = 4;
     */
    rules?: RepeatedRules;
    /**
     * @generated from protobuf oneof: view
     */
    view: {
        oneofKind: "chipsField";
        /**
         * @generated from protobuf field: c1.api.form.v1.ChipsField chips_field = 100;
         */
        chipsField: ChipsField;
    } | {
        oneofKind: "pickerField";
        /**
         * @generated from protobuf field: c1.api.form.v1.PickerField picker_field = 102;
         */
        pickerField: PickerField;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.SelectField
 */
export interface SelectField {
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.SelectOption options = 2;
     */
    options: SelectOption[];
    /**
     * @generated from protobuf field: c1.api.form.v1.SelectField.SelectType type = 3;
     */
    type: SelectField_SelectType;
}
/**
 * @generated from protobuf enum c1.api.form.v1.SelectField.SelectType
 */
export enum SelectField_SelectType {
    /**
     * @generated from protobuf enum value: SELECT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SELECT_TYPE_DROPDOWN = 1;
     */
    DROPDOWN = 1,
    /**
     * @generated from protobuf enum value: SELECT_TYPE_RADIO = 2;
     */
    RADIO = 2,
    /**
     * @generated from protobuf enum value: SELECT_TYPE_BUTTONS = 3;
     */
    BUTTONS = 3
}
/**
 * @generated from protobuf message c1.api.form.v1.SelectOption
 */
export interface SelectOption {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string value = 2;
     */
    value: string;
    /**
     * Used for type BUTTONS
     *
     * @generated from protobuf field: string description = 3;
     */
    description: string;
}
/**
 * @generated from protobuf message c1.api.form.v1.ChipsField
 */
export interface ChipsField {
}
/**
 * @generated from protobuf message c1.api.form.v1.PickerField
 */
export interface PickerField {
    /**
     * @generated from protobuf oneof: type
     */
    type: {
        oneofKind: "appUserPicker";
        /**
         * @generated from protobuf field: c1.api.form.v1.AppUserFilter app_user_picker = 100;
         */
        appUserPicker: AppUserFilter;
    } | {
        oneofKind: "resourcePicker";
        /**
         * @generated from protobuf field: c1.api.form.v1.AppResourceFilter resource_picker = 101;
         */
        resourcePicker: AppResourceFilter;
    } | {
        oneofKind: "c1UserPicker";
        /**
         * C1UserFilter is used to select ConductorOne users (not app users/accounts).
         *
         * @generated from protobuf field: c1.api.form.v1.C1UserFilter c1_user_picker = 102;
         */
        c1UserPicker: C1UserFilter;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.AppUserFilter
 */
export interface AppUserFilter {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.form.v1.AppResourceFilter
 */
export interface AppResourceFilter {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 2;
     */
    resourceTypeId: string;
}
/**
 * C1UserFilter is used to configure a picker for selecting ConductorOne users.
 * This is distinct from AppUserFilter which selects accounts within a connected app.
 *
 * @generated from protobuf message c1.api.form.v1.C1UserFilter
 */
export interface C1UserFilter {
}
/**
 * @generated from protobuf message c1.api.form.v1.Int64Field
 */
export interface Int64Field {
    /**
     * @generated from protobuf field: optional int64 default_value = 1;
     */
    defaultValue?: number;
    /**
     * @generated from protobuf field: optional validate.Int64Rules rules = 2;
     */
    rules?: Int64Rules;
    /**
     * @generated from protobuf field: string placeholder = 3;
     */
    placeholder: string;
    /**
     * @generated from protobuf oneof: view
     */
    view: {
        oneofKind: "numberField";
        /**
         * @generated from protobuf field: c1.api.form.v1.NumberField number_field = 100;
         */
        numberField: NumberField;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.NumberField
 */
export interface NumberField {
    /**
     * @generated from protobuf field: int64 min_value = 1;
     */
    minValue: number;
    /**
     * @generated from protobuf field: int64 max_value = 2;
     */
    maxValue: number;
    /**
     * @generated from protobuf field: int64 step = 3;
     */
    step: number;
}
/**
 * @generated from protobuf message c1.api.form.v1.FileField
 */
export interface FileField {
    /**
     * @generated from protobuf field: repeated string accepted_file_types = 1;
     */
    acceptedFileTypes: string[]; // MIME types or file extensions, for html input 'accept' attribute
    /**
     * @generated from protobuf field: optional int64 max_file_size = 2;
     */
    maxFileSize?: number;
    /**
     * @generated from protobuf oneof: view
     */
    view: {
        oneofKind: "fileInputField";
        /**
         * @generated from protobuf field: c1.api.form.v1.FileInputField file_input_field = 100;
         */
        fileInputField: FileInputField;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.FileInputField
 */
export interface FileInputField {
}
/**
 * FieldRelationships can be used during form validation, or they can represent
 * information that is necessary to when it comes to visually rendering the form
 *
 * @generated from protobuf message c1.api.form.v1.FieldRelationship
 */
export interface FieldRelationship {
    /**
     * The names of the fields that share this relationship
     *
     * @generated from protobuf field: repeated string field_names = 1;
     */
    fieldNames: string[];
    /**
     * @generated from protobuf oneof: kind
     */
    kind: {
        oneofKind: "requiredTogether";
        /**
         * All or none of field_names must be filled out
         *
         * @generated from protobuf field: c1.api.form.v1.RequiredTogether required_together = 100;
         */
        requiredTogether: RequiredTogether;
    } | {
        oneofKind: "atLeastOne";
        /**
         * At least one of field_names must be filled out
         *
         * @generated from protobuf field: c1.api.form.v1.AtLeastOne at_least_one = 101;
         */
        atLeastOne: AtLeastOne;
    } | {
        oneofKind: "mutuallyExclusive";
        /**
         * All field_names in this group are mutually exclusive with one another
         *
         * @generated from protobuf field: c1.api.form.v1.MutuallyExclusive mutually_exclusive = 102;
         */
        mutuallyExclusive: MutuallyExclusive;
    } | {
        oneofKind: "dependentOn";
        /**
         * Fields in field_names are only valid if dependency_field_names are present
         *
         * @generated from protobuf field: c1.api.form.v1.DependentOn dependent_on = 103;
         */
        dependentOn: DependentOn;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.RequiredTogether
 */
export interface RequiredTogether {
}
/**
 * @generated from protobuf message c1.api.form.v1.AtLeastOne
 */
export interface AtLeastOne {
}
/**
 * @generated from protobuf message c1.api.form.v1.MutuallyExclusive
 */
export interface MutuallyExclusive {
}
/**
 * DependentOn means the fields in field_names are only valid if all fields
 * in dependency_field_names are also present
 *
 * @generated from protobuf message c1.api.form.v1.DependentOn
 */
export interface DependentOn {
    /**
     * The fields that must be present for the primary field_names to be valid
     *
     * @generated from protobuf field: repeated string dependency_field_names = 1;
     */
    dependencyFieldNames: string[];
}
/**
 * @generated from protobuf message c1.api.form.v1.FieldGroup
 */
export interface FieldGroup {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string; // Unique ID.
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string help_text = 3;
     */
    helpText: string;
    /**
     * @generated from protobuf field: repeated string fields = 4;
     */
    fields: string[];
    /**
     * @generated from protobuf field: bool default = 5;
     */
    default: boolean;
}
/**
 * FormSchema represents a form template that can be used to create forms
 *
 * @generated from protobuf message c1.api.form.v1.FormSchema
 */
export interface FormSchema {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: c1.api.form.v1.Form form = 3;
     */
    form?: Form;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
    /**
     * Indicates the usage context for this form schema.
     *
     * @generated from protobuf field: c1.api.form.v1.FormSchemaUsageContext usage_context = 7;
     */
    usageContext: FormSchemaUsageContext;
}
/**
 * FormSchemaRef is a reference to a FormSchema
 *
 * @generated from protobuf message c1.api.form.v1.FormSchemaRef
 */
export interface FormSchemaRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * Request/Response messages for FormSchemaService
 *
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceCreateRequest
 */
export interface FormSchemaServiceCreateRequest {
    /**
     * @generated from protobuf field: c1.api.form.v1.Form form = 1;
     */
    form?: Form;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * Indicates the usage context for this form schema.
     *
     * @generated from protobuf field: c1.api.form.v1.FormSchemaUsageContext usage_context = 3;
     */
    usageContext: FormSchemaUsageContext;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceCreateResponse
 */
export interface FormSchemaServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.form.v1.FormSchema form_schema = 1;
     */
    formSchema?: FormSchema;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceGetRequest
 */
export interface FormSchemaServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceGetResponse
 */
export interface FormSchemaServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.form.v1.FormSchema form_schema = 1;
     */
    formSchema?: FormSchema;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceListRequest
 */
export interface FormSchemaServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.FormSchemaRef refs = 3;
     */
    refs: FormSchemaRef[];
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceListResponse
 */
export interface FormSchemaServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.FormSchema form_schemas = 1;
     */
    formSchemas: FormSchema[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceUpdateRequest
 */
export interface FormSchemaServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.form.v1.FormSchema form_schema = 1;
     */
    formSchema?: FormSchema;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceUpdateResponse
 */
export interface FormSchemaServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.form.v1.FormSchema form_schema = 1;
     */
    formSchema?: FormSchema;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceDeleteRequest
 */
export interface FormSchemaServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceDeleteResponse
 */
export interface FormSchemaServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceSearchRequest
 */
export interface FormSchemaServiceSearchRequest {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * Filter by usage context types.
     *
     * @generated from protobuf field: repeated c1.api.form.v1.FormSchemaUsageContext usage_contexts = 4;
     */
    usageContexts: FormSchemaUsageContext[];
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceSearchResponse
 */
export interface FormSchemaServiceSearchResponse {
    /**
     * Deprecated: Use list instead.
     *
     * @deprecated
     * @generated from protobuf field: repeated c1.api.form.v1.FormSchema form_schemas = 1 [deprecated = true];
     */
    formSchemas: FormSchema[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.FormSchema list = 3;
     */
    list: FormSchema[];
}
/**
 * Indicates the usage context for a FormSchema.
 *
 * @generated from protobuf enum c1.api.form.v1.FormSchemaUsageContext
 */
export enum FormSchemaUsageContext {
    /**
     * @generated from protobuf enum value: FORM_SCHEMA_USAGE_CONTEXT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Used in automations.
     *
     * @generated from protobuf enum value: FORM_SCHEMA_USAGE_CONTEXT_AUTOMATION = 1;
     */
    AUTOMATION = 1,
    /**
     * Used for resource actions.
     *
     * @generated from protobuf enum value: FORM_SCHEMA_USAGE_CONTEXT_RESOURCE_ACTION = 2;
     */
    RESOURCE_ACTION = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class Form$Type extends MessageType<Form> {
    constructor() {
        super("c1.api.form.v1.Form", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field },
            { no: 6, name: "field_relationships", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FieldRelationship },
            { no: 7, name: "field_groups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FieldGroup }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Request_Schema" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.Form
 */
export const Form = new Form$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Field$Type extends MessageType<Field> {
    constructor() {
        super("c1.api.form.v1.Field", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "required", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "string_field", kind: "message", oneof: "type", T: () => StringField },
            { no: 101, name: "bool_field", kind: "message", oneof: "type", T: () => BoolField },
            { no: 102, name: "string_slice_field", kind: "message", oneof: "type", T: () => StringSliceField },
            { no: 103, name: "int64_field", kind: "message", oneof: "type", T: () => Int64Field },
            { no: 104, name: "file_field", kind: "message", oneof: "type", T: () => FileField },
            { no: 105, name: "oauth2_field", kind: "message", oneof: "type", T: () => Oauth2Field },
            { no: 200, name: "user_config", kind: "message", oneof: "providerConfig", T: () => UserProviderConfig },
            { no: 201, name: "admin_config", kind: "message", oneof: "providerConfig", T: () => AdminProviderConfig },
            { no: 202, name: "shared_config", kind: "message", oneof: "providerConfig", T: () => SharedProviderConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.Field
 */
export const Field = new Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserProviderConfig$Type extends MessageType<UserProviderConfig> {
    constructor() {
        super("c1.api.form.v1.UserProviderConfig", [
            { no: 1, name: "input_transformation_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.UserProviderConfig
 */
export const UserProviderConfig = new UserProviderConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdminProviderConfig$Type extends MessageType<AdminProviderConfig> {
    constructor() {
        super("c1.api.form.v1.AdminProviderConfig", [
            { no: 1, name: "default_value_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "show_to_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.AdminProviderConfig
 */
export const AdminProviderConfig = new AdminProviderConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SharedProviderConfig$Type extends MessageType<SharedProviderConfig> {
    constructor() {
        super("c1.api.form.v1.SharedProviderConfig", [
            { no: 1, name: "default_value_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "lock_default_values", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "input_transformation_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.SharedProviderConfig
 */
export const SharedProviderConfig = new SharedProviderConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StringField$Type extends MessageType<StringField> {
    constructor() {
        super("c1.api.form.v1.StringField", [
            { no: 1, name: "default_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "rules", kind: "message", T: () => StringRules },
            { no: 3, name: "placeholder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "text_field", kind: "message", oneof: "view", T: () => TextField },
            { no: 101, name: "password_field", kind: "message", oneof: "view", T: () => PasswordField },
            { no: 104, name: "select_field", kind: "message", oneof: "view", T: () => SelectField },
            { no: 103, name: "picker_field", kind: "message", oneof: "view", T: () => PickerField }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.StringField
 */
export const StringField = new StringField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextField$Type extends MessageType<TextField> {
    constructor() {
        super("c1.api.form.v1.TextField", [
            { no: 1, name: "multiline", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.TextField
 */
export const TextField = new TextField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordField$Type extends MessageType<PasswordField> {
    constructor() {
        super("c1.api.form.v1.PasswordField", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.PasswordField
 */
export const PasswordField = new PasswordField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Oauth2Field$Type extends MessageType<Oauth2Field> {
    constructor() {
        super("c1.api.form.v1.Oauth2Field", [
            { no: 100, name: "oauth2_field_view", kind: "message", oneof: "view", T: () => Oauth2FieldView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.Oauth2Field
 */
export const Oauth2Field = new Oauth2Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Oauth2FieldView$Type extends MessageType<Oauth2FieldView> {
    constructor() {
        super("c1.api.form.v1.Oauth2FieldView", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.Oauth2FieldView
 */
export const Oauth2FieldView = new Oauth2FieldView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BoolField$Type extends MessageType<BoolField> {
    constructor() {
        super("c1.api.form.v1.BoolField", [
            { no: 1, name: "default_value", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "rules", kind: "message", T: () => BoolRules },
            { no: 100, name: "checkbox_field", kind: "message", oneof: "view", T: () => CheckboxField },
            { no: 101, name: "toggle_field", kind: "message", oneof: "view", T: () => ToggleField }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.BoolField
 */
export const BoolField = new BoolField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckboxField$Type extends MessageType<CheckboxField> {
    constructor() {
        super("c1.api.form.v1.CheckboxField", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.CheckboxField
 */
export const CheckboxField = new CheckboxField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToggleField$Type extends MessageType<ToggleField> {
    constructor() {
        super("c1.api.form.v1.ToggleField", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.ToggleField
 */
export const ToggleField = new ToggleField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StringSliceField$Type extends MessageType<StringSliceField> {
    constructor() {
        super("c1.api.form.v1.StringSliceField", [
            { no: 1, name: "default_values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "placeholder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "rules", kind: "message", T: () => RepeatedRules },
            { no: 100, name: "chips_field", kind: "message", oneof: "view", T: () => ChipsField },
            { no: 102, name: "picker_field", kind: "message", oneof: "view", T: () => PickerField }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.StringSliceField
 */
export const StringSliceField = new StringSliceField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SelectField$Type extends MessageType<SelectField> {
    constructor() {
        super("c1.api.form.v1.SelectField", [
            { no: 2, name: "options", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SelectOption },
            { no: 3, name: "type", kind: "enum", T: () => ["c1.api.form.v1.SelectField.SelectType", SelectField_SelectType, "SELECT_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.SelectField
 */
export const SelectField = new SelectField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SelectOption$Type extends MessageType<SelectOption> {
    constructor() {
        super("c1.api.form.v1.SelectOption", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.SelectOption
 */
export const SelectOption = new SelectOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChipsField$Type extends MessageType<ChipsField> {
    constructor() {
        super("c1.api.form.v1.ChipsField", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.ChipsField
 */
export const ChipsField = new ChipsField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PickerField$Type extends MessageType<PickerField> {
    constructor() {
        super("c1.api.form.v1.PickerField", [
            { no: 100, name: "app_user_picker", kind: "message", oneof: "type", T: () => AppUserFilter },
            { no: 101, name: "resource_picker", kind: "message", oneof: "type", T: () => AppResourceFilter },
            { no: 102, name: "c1_user_picker", kind: "message", oneof: "type", T: () => C1UserFilter }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.PickerField
 */
export const PickerField = new PickerField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserFilter$Type extends MessageType<AppUserFilter> {
    constructor() {
        super("c1.api.form.v1.AppUserFilter", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.AppUserFilter
 */
export const AppUserFilter = new AppUserFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceFilter$Type extends MessageType<AppResourceFilter> {
    constructor() {
        super("c1.api.form.v1.AppResourceFilter", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.AppResourceFilter
 */
export const AppResourceFilter = new AppResourceFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class C1UserFilter$Type extends MessageType<C1UserFilter> {
    constructor() {
        super("c1.api.form.v1.C1UserFilter", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.C1UserFilter
 */
export const C1UserFilter = new C1UserFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Int64Field$Type extends MessageType<Int64Field> {
    constructor() {
        super("c1.api.form.v1.Int64Field", [
            { no: 1, name: "default_value", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "rules", kind: "message", T: () => Int64Rules },
            { no: 3, name: "placeholder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "number_field", kind: "message", oneof: "view", T: () => NumberField }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.Int64Field
 */
export const Int64Field = new Int64Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NumberField$Type extends MessageType<NumberField> {
    constructor() {
        super("c1.api.form.v1.NumberField", [
            { no: 1, name: "min_value", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "max_value", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "step", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.NumberField
 */
export const NumberField = new NumberField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileField$Type extends MessageType<FileField> {
    constructor() {
        super("c1.api.form.v1.FileField", [
            { no: 1, name: "accepted_file_types", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "max_file_size", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 100, name: "file_input_field", kind: "message", oneof: "view", T: () => FileInputField }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FileField
 */
export const FileField = new FileField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileInputField$Type extends MessageType<FileInputField> {
    constructor() {
        super("c1.api.form.v1.FileInputField", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FileInputField
 */
export const FileInputField = new FileInputField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FieldRelationship$Type extends MessageType<FieldRelationship> {
    constructor() {
        super("c1.api.form.v1.FieldRelationship", [
            { no: 1, name: "field_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "required_together", kind: "message", oneof: "kind", T: () => RequiredTogether },
            { no: 101, name: "at_least_one", kind: "message", oneof: "kind", T: () => AtLeastOne },
            { no: 102, name: "mutually_exclusive", kind: "message", oneof: "kind", T: () => MutuallyExclusive },
            { no: 103, name: "dependent_on", kind: "message", oneof: "kind", T: () => DependentOn }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FieldRelationship
 */
export const FieldRelationship = new FieldRelationship$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequiredTogether$Type extends MessageType<RequiredTogether> {
    constructor() {
        super("c1.api.form.v1.RequiredTogether", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.RequiredTogether
 */
export const RequiredTogether = new RequiredTogether$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AtLeastOne$Type extends MessageType<AtLeastOne> {
    constructor() {
        super("c1.api.form.v1.AtLeastOne", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.AtLeastOne
 */
export const AtLeastOne = new AtLeastOne$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MutuallyExclusive$Type extends MessageType<MutuallyExclusive> {
    constructor() {
        super("c1.api.form.v1.MutuallyExclusive", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.MutuallyExclusive
 */
export const MutuallyExclusive = new MutuallyExclusive$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DependentOn$Type extends MessageType<DependentOn> {
    constructor() {
        super("c1.api.form.v1.DependentOn", [
            { no: 1, name: "dependency_field_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.DependentOn
 */
export const DependentOn = new DependentOn$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FieldGroup$Type extends MessageType<FieldGroup> {
    constructor() {
        super("c1.api.form.v1.FieldGroup", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "help_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "fields", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FieldGroup
 */
export const FieldGroup = new FieldGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchema$Type extends MessageType<FormSchema> {
    constructor() {
        super("c1.api.form.v1.FormSchema", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "form", kind: "message", T: () => Form },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "usage_context", kind: "enum", T: () => ["c1.api.form.v1.FormSchemaUsageContext", FormSchemaUsageContext, "FORM_SCHEMA_USAGE_CONTEXT_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchema
 */
export const FormSchema = new FormSchema$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaRef$Type extends MessageType<FormSchemaRef> {
    constructor() {
        super("c1.api.form.v1.FormSchemaRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaRef
 */
export const FormSchemaRef = new FormSchemaRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceCreateRequest$Type extends MessageType<FormSchemaServiceCreateRequest> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceCreateRequest", [
            { no: 1, name: "form", kind: "message", T: () => Form, options: { "validate.rules": { message: { required: true } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "usage_context", kind: "enum", T: () => ["c1.api.form.v1.FormSchemaUsageContext", FormSchemaUsageContext, "FORM_SCHEMA_USAGE_CONTEXT_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceCreateRequest
 */
export const FormSchemaServiceCreateRequest = new FormSchemaServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceCreateResponse$Type extends MessageType<FormSchemaServiceCreateResponse> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceCreateResponse", [
            { no: 1, name: "form_schema", kind: "message", T: () => FormSchema }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceCreateResponse
 */
export const FormSchemaServiceCreateResponse = new FormSchemaServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceGetRequest$Type extends MessageType<FormSchemaServiceGetRequest> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceGetRequest
 */
export const FormSchemaServiceGetRequest = new FormSchemaServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceGetResponse$Type extends MessageType<FormSchemaServiceGetResponse> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceGetResponse", [
            { no: 1, name: "form_schema", kind: "message", T: () => FormSchema }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceGetResponse
 */
export const FormSchemaServiceGetResponse = new FormSchemaServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceListRequest$Type extends MessageType<FormSchemaServiceListRequest> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FormSchemaRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceListRequest
 */
export const FormSchemaServiceListRequest = new FormSchemaServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceListResponse$Type extends MessageType<FormSchemaServiceListResponse> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceListResponse", [
            { no: 1, name: "form_schemas", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FormSchema },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceListResponse
 */
export const FormSchemaServiceListResponse = new FormSchemaServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceUpdateRequest$Type extends MessageType<FormSchemaServiceUpdateRequest> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceUpdateRequest", [
            { no: 1, name: "form_schema", kind: "message", T: () => FormSchema, options: { "validate.rules": { message: { required: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceUpdateRequest
 */
export const FormSchemaServiceUpdateRequest = new FormSchemaServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceUpdateResponse$Type extends MessageType<FormSchemaServiceUpdateResponse> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceUpdateResponse", [
            { no: 1, name: "form_schema", kind: "message", T: () => FormSchema }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceUpdateResponse
 */
export const FormSchemaServiceUpdateResponse = new FormSchemaServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceDeleteRequest$Type extends MessageType<FormSchemaServiceDeleteRequest> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceDeleteRequest
 */
export const FormSchemaServiceDeleteRequest = new FormSchemaServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceDeleteResponse$Type extends MessageType<FormSchemaServiceDeleteResponse> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceDeleteResponse
 */
export const FormSchemaServiceDeleteResponse = new FormSchemaServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceSearchRequest$Type extends MessageType<FormSchemaServiceSearchRequest> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "usage_contexts", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.form.v1.FormSchemaUsageContext", FormSchemaUsageContext, "FORM_SCHEMA_USAGE_CONTEXT_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceSearchRequest
 */
export const FormSchemaServiceSearchRequest = new FormSchemaServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceSearchResponse$Type extends MessageType<FormSchemaServiceSearchResponse> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceSearchResponse", [
            { no: 1, name: "form_schemas", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FormSchema },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FormSchema }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceSearchResponse
 */
export const FormSchemaServiceSearchResponse = new FormSchemaServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.form.v1.FormSchemaService
 */
export const FormSchemaService = new ServiceType("c1.api.form.v1.FormSchemaService", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: FormSchemaServiceCreateRequest, O: FormSchemaServiceCreateResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: FormSchemaServiceGetRequest, O: FormSchemaServiceGetResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: FormSchemaServiceListRequest, O: FormSchemaServiceListResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: FormSchemaServiceUpdateRequest, O: FormSchemaServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: FormSchemaServiceDeleteRequest, O: FormSchemaServiceDeleteResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: FormSchemaServiceSearchRequest, O: FormSchemaServiceSearchResponse }
]);
